import * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import { PersonDetailDataFragmentDoc } from '../editor.generated';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type TeacherQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;

export type TeacherQuery = {
  __typename?: 'Query';
  person: {
    __typename?: 'Person';
    internalNotes?: string | null;
    enterpriseIds?: Array<any> | null;
    id: any;
    createdAt: any;
    title?: string | null;
    gender?: Types.Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    anonymizedAt?: any | null;
    employments: Array<{
      __typename?: 'Employment';
      id: any;
      description?: string | null;
      companyId: any;
      company: { __typename?: 'Company'; id: any; name: string };
    }>;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    user?:
      | {
          __typename?: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Customer';
          invoiceEmail?: string | null;
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          orders: Array<{
            __typename?: 'Order';
            id: any;
            createdAt: any;
            total: number;
          }>;
          bookings: Array<
            | {
                __typename?: 'CourseModuleBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseModule: {
                  __typename?: 'CourseModule';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  courseUnit: {
                    __typename?: 'CourseUnit';
                    id: any;
                    course: {
                      __typename?: 'Course';
                      id: any;
                      title: string;
                      verboseTitle?: string | null;
                      abbreviation: string;
                    };
                  };
                };
              }
            | {
                __typename?: 'CourseUnitBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              }
          >;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Teacher';
          jobTitle?: string | null;
          subjectArea?: string | null;
          slug?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | null;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      id: any;
      key: Types.ContactPropertyKey;
      value: string;
    }>;
    inquiries: Array<{
      __typename?: 'Inquiry';
      id: any;
      createdAt: any;
      status: Types.InquiryStatus;
      assignee?: {
        __typename?: 'Administrator';
        id: any;
        fullName: string;
      } | null;
    }>;
    address: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    invoiceAddress: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
  };
};

export type UpdateTeacherMutationVariables = Types.Exact<{
  userInput: Types.TeacherInput;
  personInput: Types.PersonInput;
  id: Types.Scalars['UUID'];
}>;

export type UpdateTeacherMutation = {
  __typename?: 'Mutation';
  adminEditTeacher: {
    __typename?: 'Person';
    internalNotes?: string | null;
    enterpriseIds?: Array<any> | null;
    id: any;
    createdAt: any;
    title?: string | null;
    gender?: Types.Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    anonymizedAt?: any | null;
    employments: Array<{
      __typename?: 'Employment';
      id: any;
      description?: string | null;
      companyId: any;
      company: { __typename?: 'Company'; id: any; name: string };
    }>;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    user?:
      | {
          __typename?: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Customer';
          invoiceEmail?: string | null;
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          orders: Array<{
            __typename?: 'Order';
            id: any;
            createdAt: any;
            total: number;
          }>;
          bookings: Array<
            | {
                __typename?: 'CourseModuleBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseModule: {
                  __typename?: 'CourseModule';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  courseUnit: {
                    __typename?: 'CourseUnit';
                    id: any;
                    course: {
                      __typename?: 'Course';
                      id: any;
                      title: string;
                      verboseTitle?: string | null;
                      abbreviation: string;
                    };
                  };
                };
              }
            | {
                __typename?: 'CourseUnitBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              }
          >;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Teacher';
          jobTitle?: string | null;
          subjectArea?: string | null;
          slug?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | null;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      id: any;
      key: Types.ContactPropertyKey;
      value: string;
    }>;
    inquiries: Array<{
      __typename?: 'Inquiry';
      id: any;
      createdAt: any;
      status: Types.InquiryStatus;
      assignee?: {
        __typename?: 'Administrator';
        id: any;
        fullName: string;
      } | null;
    }>;
    address: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    invoiceAddress: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
  };
};

export type CreateTeacherMutationVariables = Types.Exact<{
  userInput: Types.TeacherInput;
  personInput: Types.PersonInput;
}>;

export type CreateTeacherMutation = {
  __typename?: 'Mutation';
  adminCreateTeacher: {
    __typename?: 'Person';
    internalNotes?: string | null;
    enterpriseIds?: Array<any> | null;
    id: any;
    createdAt: any;
    title?: string | null;
    gender?: Types.Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    anonymizedAt?: any | null;
    employments: Array<{
      __typename?: 'Employment';
      id: any;
      description?: string | null;
      companyId: any;
      company: { __typename?: 'Company'; id: any; name: string };
    }>;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    user?:
      | {
          __typename?: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Customer';
          invoiceEmail?: string | null;
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          orders: Array<{
            __typename?: 'Order';
            id: any;
            createdAt: any;
            total: number;
          }>;
          bookings: Array<
            | {
                __typename?: 'CourseModuleBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseModule: {
                  __typename?: 'CourseModule';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  courseUnit: {
                    __typename?: 'CourseUnit';
                    id: any;
                    course: {
                      __typename?: 'Course';
                      id: any;
                      title: string;
                      verboseTitle?: string | null;
                      abbreviation: string;
                    };
                  };
                };
              }
            | {
                __typename?: 'CourseUnitBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              }
          >;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Teacher';
          jobTitle?: string | null;
          subjectArea?: string | null;
          slug?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | null;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      id: any;
      key: Types.ContactPropertyKey;
      value: string;
    }>;
    inquiries: Array<{
      __typename?: 'Inquiry';
      id: any;
      createdAt: any;
      status: Types.InquiryStatus;
      assignee?: {
        __typename?: 'Administrator';
        id: any;
        fullName: string;
      } | null;
    }>;
    address: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    invoiceAddress: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
  };
};

export type UpdateTeacherFilesMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
  input: Types.UpdateUserFilesInput;
}>;

export type UpdateTeacherFilesMutation = {
  __typename?: 'Mutation';
  adminUpdateUserFiles: boolean;
};

export type DeleteTeacherMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;

export type DeleteTeacherMutation = {
  __typename?: 'Mutation';
  adminDeleteTeacher: boolean;
};

export const TeacherDocument = gql`
  query teacher($id: UUID!) {
    person(id: $id) {
      ...PersonDetailData
    }
  }
  ${PersonDetailDataFragmentDoc}
`;
export type TeacherComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TeacherQuery,
    TeacherQueryVariables
  >,
  'query'
> &
  ({ variables: TeacherQueryVariables; skip?: boolean } | { skip: boolean });

export const TeacherComponent = (props: TeacherComponentProps) => (
  <ApolloReactComponents.Query<TeacherQuery, TeacherQueryVariables>
    query={TeacherDocument}
    {...props}
  />
);

/**
 * __useTeacherQuery__
 *
 * To run a query within a React component, call `useTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeacherQuery(
  baseOptions: Apollo.QueryHookOptions<TeacherQuery, TeacherQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TeacherQuery, TeacherQueryVariables>(
    TeacherDocument,
    options,
  );
}
export function useTeacherLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TeacherQuery,
    TeacherQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TeacherQuery, TeacherQueryVariables>(
    TeacherDocument,
    options,
  );
}
export type TeacherQueryHookResult = ReturnType<typeof useTeacherQuery>;
export type TeacherLazyQueryHookResult = ReturnType<typeof useTeacherLazyQuery>;
export type TeacherQueryResult = Apollo.QueryResult<
  TeacherQuery,
  TeacherQueryVariables
>;
export const UpdateTeacherDocument = gql`
  mutation updateTeacher(
    $userInput: TeacherInput!
    $personInput: PersonInput!
    $id: UUID!
  ) {
    adminEditTeacher(
      userInput: $userInput
      personInput: $personInput
      id: $id
    ) {
      ...PersonDetailData
    }
  }
  ${PersonDetailDataFragmentDoc}
`;
export type UpdateTeacherMutationFn = Apollo.MutationFunction<
  UpdateTeacherMutation,
  UpdateTeacherMutationVariables
>;
export type UpdateTeacherComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateTeacherMutation,
    UpdateTeacherMutationVariables
  >,
  'mutation'
>;

export const UpdateTeacherComponent = (props: UpdateTeacherComponentProps) => (
  <ApolloReactComponents.Mutation<
    UpdateTeacherMutation,
    UpdateTeacherMutationVariables
  >
    mutation={UpdateTeacherDocument}
    {...props}
  />
);

/**
 * __useUpdateTeacherMutation__
 *
 * To run a mutation, you first call `useUpdateTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeacherMutation, { data, loading, error }] = useUpdateTeacherMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      personInput: // value for 'personInput'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateTeacherMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeacherMutation,
    UpdateTeacherMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTeacherMutation,
    UpdateTeacherMutationVariables
  >(UpdateTeacherDocument, options);
}
export type UpdateTeacherMutationHookResult = ReturnType<
  typeof useUpdateTeacherMutation
>;
export type UpdateTeacherMutationResult =
  Apollo.MutationResult<UpdateTeacherMutation>;
export type UpdateTeacherMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeacherMutation,
  UpdateTeacherMutationVariables
>;
export const CreateTeacherDocument = gql`
  mutation createTeacher(
    $userInput: TeacherInput!
    $personInput: PersonInput!
  ) {
    adminCreateTeacher(personInput: $personInput, userInput: $userInput) {
      ...PersonDetailData
    }
  }
  ${PersonDetailDataFragmentDoc}
`;
export type CreateTeacherMutationFn = Apollo.MutationFunction<
  CreateTeacherMutation,
  CreateTeacherMutationVariables
>;
export type CreateTeacherComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateTeacherMutation,
    CreateTeacherMutationVariables
  >,
  'mutation'
>;

export const CreateTeacherComponent = (props: CreateTeacherComponentProps) => (
  <ApolloReactComponents.Mutation<
    CreateTeacherMutation,
    CreateTeacherMutationVariables
  >
    mutation={CreateTeacherDocument}
    {...props}
  />
);

/**
 * __useCreateTeacherMutation__
 *
 * To run a mutation, you first call `useCreateTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeacherMutation, { data, loading, error }] = useCreateTeacherMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      personInput: // value for 'personInput'
 *   },
 * });
 */
export function useCreateTeacherMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTeacherMutation,
    CreateTeacherMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTeacherMutation,
    CreateTeacherMutationVariables
  >(CreateTeacherDocument, options);
}
export type CreateTeacherMutationHookResult = ReturnType<
  typeof useCreateTeacherMutation
>;
export type CreateTeacherMutationResult =
  Apollo.MutationResult<CreateTeacherMutation>;
export type CreateTeacherMutationOptions = Apollo.BaseMutationOptions<
  CreateTeacherMutation,
  CreateTeacherMutationVariables
>;
export const UpdateTeacherFilesDocument = gql`
  mutation updateTeacherFiles($id: UUID!, $input: UpdateUserFilesInput!) {
    adminUpdateUserFiles(id: $id, input: $input)
  }
`;
export type UpdateTeacherFilesMutationFn = Apollo.MutationFunction<
  UpdateTeacherFilesMutation,
  UpdateTeacherFilesMutationVariables
>;
export type UpdateTeacherFilesComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateTeacherFilesMutation,
    UpdateTeacherFilesMutationVariables
  >,
  'mutation'
>;

export const UpdateTeacherFilesComponent = (
  props: UpdateTeacherFilesComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateTeacherFilesMutation,
    UpdateTeacherFilesMutationVariables
  >
    mutation={UpdateTeacherFilesDocument}
    {...props}
  />
);

/**
 * __useUpdateTeacherFilesMutation__
 *
 * To run a mutation, you first call `useUpdateTeacherFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeacherFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeacherFilesMutation, { data, loading, error }] = useUpdateTeacherFilesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeacherFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeacherFilesMutation,
    UpdateTeacherFilesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTeacherFilesMutation,
    UpdateTeacherFilesMutationVariables
  >(UpdateTeacherFilesDocument, options);
}
export type UpdateTeacherFilesMutationHookResult = ReturnType<
  typeof useUpdateTeacherFilesMutation
>;
export type UpdateTeacherFilesMutationResult =
  Apollo.MutationResult<UpdateTeacherFilesMutation>;
export type UpdateTeacherFilesMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeacherFilesMutation,
  UpdateTeacherFilesMutationVariables
>;
export const DeleteTeacherDocument = gql`
  mutation deleteTeacher($id: UUID!) {
    adminDeleteTeacher(id: $id)
  }
`;
export type DeleteTeacherMutationFn = Apollo.MutationFunction<
  DeleteTeacherMutation,
  DeleteTeacherMutationVariables
>;
export type DeleteTeacherComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteTeacherMutation,
    DeleteTeacherMutationVariables
  >,
  'mutation'
>;

export const DeleteTeacherComponent = (props: DeleteTeacherComponentProps) => (
  <ApolloReactComponents.Mutation<
    DeleteTeacherMutation,
    DeleteTeacherMutationVariables
  >
    mutation={DeleteTeacherDocument}
    {...props}
  />
);

/**
 * __useDeleteTeacherMutation__
 *
 * To run a mutation, you first call `useDeleteTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeacherMutation, { data, loading, error }] = useDeleteTeacherMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeacherMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTeacherMutation,
    DeleteTeacherMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteTeacherMutation,
    DeleteTeacherMutationVariables
  >(DeleteTeacherDocument, options);
}
export type DeleteTeacherMutationHookResult = ReturnType<
  typeof useDeleteTeacherMutation
>;
export type DeleteTeacherMutationResult =
  Apollo.MutationResult<DeleteTeacherMutation>;
export type DeleteTeacherMutationOptions = Apollo.BaseMutationOptions<
  DeleteTeacherMutation,
  DeleteTeacherMutationVariables
>;
